import angular from 'angular';

import ComponentModule from './component';
import CalendarPeriodComponent from './calendar-period.cmpt';

export default angular
    .module('application.scene.authorized.scene.calendar.component.calendar-header.component.calendar-period', [
        ComponentModule.name
    ])
    .component(CalendarPeriodComponent.selector, CalendarPeriodComponent);



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/calendar/component/calendar-header/component/calendar-period/index.js